const errorKey = 'unu-stringified-error';

const stringifyErrors = data => {

  if (data instanceof Error) {

    return {
      [errorKey]: JSON.stringify(data, Object.getOwnPropertyNames(data)),
    };
  }

  if (Array.isArray(data)) {

    const stringified = [];

    for (const arg of data) {
      stringified.push(stringifyErrors(arg));
    }

    return stringified;
  }

  if (typeof data === 'object') {

    const stringified = {};

    for (const [argName, argValue] of Object.entries(data)) {
      stringified[argName] = stringifyErrors(argValue);
    }

    return stringified;
  }

  return data;
};

const parseErrors = data => {

  if (data?.[errorKey]) {
    return Object.assign(new Error(), JSON.parse(data[errorKey]));
  }

  if (Array.isArray(data)) {

    const constructed = [];

    for (const arg of data) {
      constructed.push(parseErrors(arg));
    }

    return constructed;
  }

  if (typeof data === 'object') {

    const constructed = {};

    for (const [argName, argValue] of Object.entries(data)) {
      constructed[argName] = parseErrors(argValue);
    }

    return constructed;
  }

  return data;
};

export const buildMessage = ({
  name,
  data,
} = {}) => {

  if (!name) {
    return;
  }

  return JSON.stringify({
    name,
    data: stringifyErrors(data),
  });
};

export const parseMessage = message => {

  if (!message) {
    return;
  }

  const parsed = JSON.parse(message);

  return {
    name: parsed?.name,
    data: parseErrors(parsed?.data),
  };
};